import React, { useMemo, useState } from 'react'
import { Dropdown } from 'rsuite'
import { useTranslation } from "react-i18next"
import Flag from './Flag'
import config from '../config'
import { useAuth } from './AuthProvider'
import useLocalStorage from '../utils/useLocalStorage'

type LanguagesProps = { symbol: string, label: string, country: string }

const languages: LanguagesProps[] = config.languages

type LanguageSwitcherProp = { mode?: 'text' | 'flag' | 'text-and-flag', style?: React.CSSProperties }

//const LanguageSwitcher = ({ language, setLanguage }) => {
export default function LanguageSwitcher({ mode = 'text-and-flag', style = {} }: LanguageSwitcherProp) {
  const [lang, setLang] = useLocalStorage<string>('lng', '', false)
  const { setSettings } = useAuth()
  const { i18n } = useTranslation()
  const [language, setLanguage] = useState<string>(i18n.language?.split('-')[0] || 'en')


  const handleChangeLanguage = (lng: string) => {
    setSettings('language', lng)
    i18n.changeLanguage(lng)
    setLanguage(lng)
    //setLanguage(lng)
  }

  const getLanguage = (lng: string): LanguagesProps => {
    const result = languages.find(item => {
      //console.log('ChangeLanguage.getLanguage:', item)
      return item.symbol === lng
    })
    //console.log('ChangeLanguage.getLanguage:', result)
    return result as LanguagesProps
  }

  const list = languages.map((item, index) => {
    if (mode === 'text')
      return <Dropdown.Item key={index} eventKey={item.symbol}>{item.label}</Dropdown.Item>
    if (mode === 'flag')
      return <Dropdown.Item key={index} eventKey={item.symbol}><Flag country={item.country} /></Dropdown.Item>
    return <Dropdown.Item key={index} eventKey={item.symbol}>{item.label} <Flag country={item.country} /></Dropdown.Item>
  })

  const lng = getLanguage(language)
  const title = useMemo(() => {
    if (mode === 'text')
      return <>{lng.label}</>
    if (mode === 'flag')
      return <><Flag country={lng.country} /></>
    return <>{lng.label} <Flag country={lng.country} /></>
  }, [mode, language])

  return (
    <Dropdown
      title={title}
      onSelect={handleChangeLanguage}
      activeKey={language}
      className="language-selector"
      style={style}
    >
      {list}
    </Dropdown>
  )
}

// const mapStateToProps = (state) => ({
//   language: state.language
// })

// const mapDispatchToProps = (dispatch) => ({
//   setLanguage: (lng) => dispatch(setLanguage(lng))
// })

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(LanguageSwitcher)
